/**
 * 平假名学习页面 - 主应用逻辑
 * 功能：渲染假名格子、弹窗详情、语音发音、摄像头扫描识别
 */

(function () {
  'use strict';

  /* ===== 工具函数 ===== */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ===== 渲染假名格子 ===== */
  function renderGrid(containerId, items) {
    const container = qs('#' + containerId);
    if (!container) return;
    container.innerHTML = '';
    items.forEach(function (item) {
      const card = document.createElement('button');
      card.className = 'hira-card hira-card--' + item.type;
      card.setAttribute('data-hira', item.hira);
      card.setAttribute('aria-label', item.hira + ' ' + item.romaji);
      card.innerHTML = `
        <span class="hira-char">${item.hira}</span>
        <span class="hira-romaji">${item.romaji}</span>
      `;
      card.addEventListener('click', function () {
        openModal(item);
      });
      container.appendChild(card);
    });
  }

  function initGrids() {
    if (typeof HIRAGANA_DATA === 'undefined') {
      console.error('[Hiragana] HIRAGANA_DATA not loaded.');
      return;
    }
    renderGrid('grid-seion',      HIRAGANA_DATA.seion);
    renderGrid('grid-dakuon',     HIRAGANA_DATA.dakuon);
    renderGrid('grid-handakuon',  HIRAGANA_DATA.handakuon);
    renderGrid('grid-youon',      HIRAGANA_DATA.youon);
    renderGrid('grid-choon',      HIRAGANA_DATA.choon);
  }

  /* ===== 弹窗逻辑 ===== */
  const overlay    = qs('#hiraModalOverlay');
  const closeBtn   = qs('#modalCloseBtn');
  const audioBtn   = qs('#modalAudioBtn');
  let currentItem  = null;

  function openModal(item) {
    currentItem = item;
    qs('#modalHiragana').textContent  = item.hira;
    qs('#modalRomaji').textContent    = item.romaji;
    qs('#modalPhonetic').textContent  = item.phonetic;
    qs('#modalKatakana').textContent  = item.kata;

    // 例词展示
    const examplesEl = qs('#modalExamples');
    if (item.example) {
      examplesEl.innerHTML = `<span class="example-label">例：</span><span class="example-text">${item.example}</span>`;
    } else {
      examplesEl.innerHTML = '';
    }

    overlay.classList.add('is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    currentItem = null;
  }

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ===== 语音发音（女性声音 Web Speech API）===== */
  function speakHiragana(text) {
    if (!('speechSynthesis' in window)) {
      alert('お使いのブラウザはテキスト読み上げに対応していません。');
      return;
    }
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(text);
    utter.lang = 'ja-JP';
    utter.rate = 0.85;
    utter.pitch = 1.5;

    // 优先选择日语女性声音
    const voices = window.speechSynthesis.getVoices();
    const jaFemale = voices.find(function (v) {
      return v.lang.startsWith('ja') && /female/i.test(v.name);
    });
    const jaAny = voices.find(function (v) { return v.lang === 'ja-JP'; });
    utter.voice = jaFemale || jaAny;

    window.speechSynthesis.speak(utter);

    // 按钮动画
    if (audioBtn) {
      audioBtn.classList.add('is-playing');
      utter.onend = function () { audioBtn.classList.remove('is-playing'); };
    }
  }

  if (audioBtn) {
    audioBtn.addEventListener('click', function () {
      if (currentItem) speakHiragana(currentItem.hira);
    });
  }

  // 确保 voices 加载完成
  if ('speechSynthesis' in window) {
    window.speechSynthesis.onvoiceschanged = function () {};
  }

  /* ===== 扫描器（摄像头 + Tesseract OCR）===== */
  /*
   * 卡牌结构（实测）：662×1016px / 300DPI / RGBA
   * 平假名字符集中在卡牌纵向 33%～67% 的中段区域
   * 字符特征：白底深色字，字体大、笔画清晰
   * 优化策略：
   *   1. 视频帧先取中央卡牌区（考虑纵横比 2:3），再按卡牌内部比例二次裁剪字符区
   *   2. 图像预处理：灰度化 → 高对比度拉伸 → 放大2倍 → 白底化
   *   3. Tesseract 配置：单字符模式 PSM=10，白名单仅含平假名
   *   4. 多策略识别：单字模式失败则回退全文模式
   */

  const scannerBtn   = qs('#openScannerBtn');
  const closeScanBtn = qs('#closeScannerBtn');
  const scanOverlay  = qs('#scannerOverlay');
  const scanVideo    = qs('#scannerVideo');
  const scanCanvas   = qs('#scannerCanvas');
  const scanHint     = qs('#scannerHint');
  const scanResult   = qs('#scannerResult');
  const scanResultTxt= qs('#scannerResultText');

  let scanStream      = null;
  let scanInterval    = null;
  let tesseractWorker = null;
  let isProcessing    = false;
  let consecutiveFails= 0;     // 连续识别失败计数（用于降级策略）
  let scanMode        = 'auto'; // 'auto' | 'manual'

  // ── 平假名白名单（Tesseract 使用）──────────────────────────────────
  const HIRA_WHITELIST =
    'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめも' +
    'やゆよらりるれろわをんがぎぐげござじずぜぞだぢづでどばびぶべぼぱぴぷぺぽ' +
    'きゃきゅきょしゃしゅしょちゃちゅちょにゃにゅにょひゃひゅひょみゃみゅみょ' +
    'りゃりゅりょぎゃぎゅぎょじゃじゅじょびゃびゅびょぴゃぴゅぴょ';

  // ── 构建假名查找表 ──────────────────────────────────────────────────
  function buildHiraMap() {
    const map = {};
    if (typeof HIRAGANA_DATA === 'undefined') return map;
    Object.values(HIRAGANA_DATA).forEach(function (arr) {
      arr.forEach(function (item) {
        // 支持长音多字条目（如「ああ」）
        map[item.hira] = item;
      });
    });
    return map;
  }
  const HIRA_MAP = buildHiraMap();

  // ── 脚本动态加载 ────────────────────────────────────────────────────
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[src="' + src + '"]')) { resolve(); return; }
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  // ── Tesseract 初始化（仅一次）────────────────────────────────────────
  async function initTesseract() {
    if (tesseractWorker) return;
    try {
      if (typeof Tesseract === 'undefined') {
        await loadScript('https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js');
      }
      tesseractWorker = await Tesseract.createWorker('jpn', 1, {
        logger: function () {},
      });
      // 设置平假名白名单，减少误识别
      await tesseractWorker.setParameters({
        tessedit_char_whitelist: HIRA_WHITELIST,
      });
    } catch (e) {
      console.error('[Scanner] Tesseract init failed:', e);
    }
  }

  // ── 摄像头启动 ───────────────────────────────────────────────────────
  async function startScanner() {
    scanOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    scanResult.style.display = 'none';
    consecutiveFails = 0;
    scanHint.textContent = 'カメラを起動中...';

    try {
      // 请求后置摄像头，尽量高分辨率
      scanStream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: 'environment' },
          width:  { ideal: 1920, min: 640 },
          height: { ideal: 1080, min: 480 },
        }
      });
      scanVideo.srcObject = scanStream;
      await scanVideo.play();
      scanHint.textContent = 'カードをフレーム中央に合わせてください';

      // 提前初始化 OCR（不阻塞界面）
      initTesseract().catch(console.error);

      // 按当前模式启动/不启动自动扫描
      if (scanMode === 'auto') {
        scanInterval = setInterval(captureAndRecognize, 1200);
      }
    } catch (err) {
      console.error('[Scanner] Camera error:', err);
      scanHint.textContent = 'カメラへのアクセスが拒否されました。ブラウザの設定を確認してください。';
    }
  }

  // ── 停止扫描 ─────────────────────────────────────────────────────────
  function stopScanner() {
    clearInterval(scanInterval);
    scanInterval = null;
    if (scanStream) {
      scanStream.getTracks().forEach(t => t.stop());
      scanStream = null;
    }
    scanVideo.srcObject = null;
    scanOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
    isProcessing = false;
  }

  // ── 计算自适应阈值（基于 ROI 灰度中位数）────────────────────────
  function computeAdaptiveThreshold(srcCtx, sx, sy, sw, sh) {
    const data = srcCtx.getImageData(sx, sy, sw, sh).data;
    const grays = [];
    for (let i = 0; i < data.length; i += 4) {
      grays.push(0.299 * data[i] + 0.587 * data[i+1] + 0.114 * data[i+2]);
    }
    grays.sort((a, b) => a - b);
    const median = grays[Math.floor(grays.length / 2)];
    // 深色文字在浅色背景上：阈值 = 中位数 - 40
    return Math.round(Math.min(Math.max(median - 40, 120), 220));
  }

  // ── 图像预处理：灰度 + 二值化 + 放大（支持自定义阈值）────────────
  function preprocessROI(srcCtx, sx, sy, sw, sh, scale, threshold) {
    scale = scale || 2;
    threshold = threshold || 180;
    const raw = srcCtx.getImageData(sx, sy, sw, sh);

    const dst = document.createElement('canvas');
    dst.width  = sw * scale;
    dst.height = sh * scale;
    const dctx = dst.getContext('2d');

    dctx.fillStyle = '#ffffff';
    dctx.fillRect(0, 0, dst.width, dst.height);

    const data = raw.data;
    for (let i = 0; i < data.length; i += 4) {
      const gray = 0.299 * data[i] + 0.587 * data[i+1] + 0.114 * data[i+2];
      const val = gray < threshold ? 0 : 255;
      data[i] = data[i+1] = data[i+2] = val;
      data[i+3] = 255;
    }

    const tmp = document.createElement('canvas');
    tmp.width = sw; tmp.height = sh;
    tmp.getContext('2d').putImageData(raw, 0, 0);

    dctx.imageSmoothingEnabled = false;
    dctx.drawImage(tmp, 0, 0, sw, sh, 0, 0, dst.width, dst.height);
    return dst;
  }

  // ── 核心截帧识别 ──────────────────────────────────────────────────────
  async function captureAndRecognize() {
    if (isProcessing || !tesseractWorker || !scanVideo.videoWidth) return;
    isProcessing = true;

    try {
      const vw = scanVideo.videoWidth;
      const vh = scanVideo.videoHeight;

      // 1. 整帧绘入 scanCanvas
      scanCanvas.width  = vw;
      scanCanvas.height = vh;
      const ctx = scanCanvas.getContext('2d');
      ctx.drawImage(scanVideo, 0, 0);

      /* ──────────────────────────────────────────────────────────────
       * 2. 卡牌定位策略
       *    卡牌纵横比约 2:3（宽:高 = 662:1016 ≈ 0.65）
       *    假设用户将卡牌竖向置于视野中央，占视频高度约 70%
       *    推算卡牌区域在视频帧中的位置：
       *      - 卡牌高度 cardH = vh * 0.70
       *      - 卡牌宽度 cardW = cardH * (662/1016)
       *      - 卡牌起点 (cardX, cardY)：居中
       * ────────────────────────────────────────────────────────────── */
      const cardH  = vh * 0.70;
      const cardW  = cardH * (662 / 1016);
      const cardX  = (vw - cardW) / 2;
      const cardY  = (vh - cardH) / 2;

      /* ──────────────────────────────────────────────────────────────
       * 3. 在卡牌区域内二次裁剪字符区
       *    实测：平假名字符位于卡牌纵向 33%～67% 的中段
       *    水平方向：卡牌 15%～85%（去除卡牌边框和装饰）
       * ────────────────────────────────────────────────────────────── */
      const roiX = Math.round(cardX + cardW * 0.15);
      const roiY = Math.round(cardY + cardH * 0.33);
      const roiW = Math.round(cardW * 0.70);
      const roiH = Math.round(cardH * 0.34);   // 33%~67% → 34% 高度

      // 安全边界检查
      const safeX = Math.max(0, Math.min(roiX, vw - 1));
      const safeY = Math.max(0, Math.min(roiY, vh - 1));
      const safeW = Math.max(1, Math.min(roiW, vw - safeX));
      const safeH = Math.max(1, Math.min(roiH, vh - safeY));

      // 4. 自适应阈值
      const adaptiveT = computeAdaptiveThreshold(ctx, safeX, safeY, safeW, safeH);

      // 各策略 OCR 原始文本收集（用于聚合候选列表）
      const rawTexts = [];

      // 5. 策略 A1：自适应阈值 + PSM=10 + 2× 放大
      try {
        await tesseractWorker.setParameters({ tessedit_pageseg_mode: '10' });
        const { data: { text: textA1 } } = await tesseractWorker.recognize(
          preprocessROI(ctx, safeX, safeY, safeW, safeH, 2, adaptiveT)
        );
        rawTexts.push(textA1);
      } catch (_) {}

      // 6. 策略 A2：固定阈值180 + PSM=10 + 2× 放大
      try {
        await tesseractWorker.setParameters({ tessedit_pageseg_mode: '10' });
        const { data: { text: textA2 } } = await tesseractWorker.recognize(
          preprocessROI(ctx, safeX, safeY, safeW, safeH, 2, 180)
        );
        rawTexts.push(textA2);
      } catch (_) {}

      // 7. 策略 B：自适应阈值 + PSM=6 + 2× 放大
      try {
        await tesseractWorker.setParameters({ tessedit_pageseg_mode: '6' });
        const { data: { text: textB } } = await tesseractWorker.recognize(
          preprocessROI(ctx, safeX, safeY, safeW, safeH, 2, adaptiveT)
        );
        rawTexts.push(textB);
      } catch (_) {}

      // 8. 策略 C：放大3倍 + 扩大区域 + 自适应阈值（连续失败3次触发）
      if (consecutiveFails >= 3) {
        const wideX = Math.max(0, safeX - Math.round(cardW * 0.05));
        const wideY = Math.max(0, safeY - Math.round(cardH * 0.05));
        const wideW = Math.min(safeW + Math.round(cardW * 0.10), vw - safeX);
        const wideH = Math.min(safeH + Math.round(cardH * 0.10), vh - safeY);
        try {
          await tesseractWorker.setParameters({ tessedit_pageseg_mode: '6' });
          const { data: { text: textC } } = await tesseractWorker.recognize(
            preprocessROI(ctx, wideX, wideY, wideW, wideH, 3, adaptiveT)
          );
          rawTexts.push(textC);
        } catch (_) {}
      }

      // 9. 聚合候选：去重、去重复字符过滤、取 TOP 3
      const candidates = buildCandidates(rawTexts);
      const found = candidates[0] || null;

      if (found) {
        consecutiveFails = 0;
        onCardRecognized(found, candidates);
      } else {
        consecutiveFails++;
        // 超过8次连续失败时提示用户调整
        if (consecutiveFails === 8) {
          scanHint.textContent = 'カードを明るい場所で、正面からフレーム内に合わせてください';
        }
      }
    } catch (e) {
      console.error('[Scanner] OCR error:', e);
    } finally {
      isProcessing = false;
    }
  }

  // ── 去重复字符过滤（核心：防止「い」被识别为「いい」）────────────────
  //   规则：单个字符连续重复 → 缩减为1个
  //         但「きゃ」「しゅ」等拗音组合不是重复 → 保留
  //   例：「いい」→「い」 「ああ」→「あ」 「きゃきゃ」→「きゃ」
  function normalizeOCRResult(text) {
    // 仅保留平假名范围字符
    const clean = text.replace(/[^\u3041-\u3096]/g, '');
    if (!clean) return clean;
    // 去除连续重复的单字符：(.)\1+ → $1
    // 注意：拗音如「きゃ」是两个不同字符，不会被此规则误删
    return clean.replace(/([\u3041-\u3096])\1+/g, '$1');
  }

  // ── 假名匹配（优先多字拗音，防止「き」误匹配「きゃ」）───────────────
  //   返回匹配到的 item，未找到返回 null
  function matchHiragana(ocrText) {
    const clean = normalizeOCRResult(ocrText);
    if (!clean) return null;
    // 按长度降序：先匹配拗音（2字），再匹配单字
    const keys = Object.keys(HIRA_MAP).sort((a, b) => b.length - a.length);
    for (const key of keys) {
      if (clean.includes(key)) return HIRA_MAP[key];
    }
    return null;
  }

  // ── 多策略结果聚合，返回去重后的 TOP N 候选列表 ──────────────────────
  function buildCandidates(rawResults) {
    const seen = new Set();
    const list = [];
    for (const text of rawResults) {
      if (!text) continue;
      const item = matchHiragana(text);
      if (item && !seen.has(item.hira)) {
        seen.add(item.hira);
        list.push(item);
      }
    }
    return list.slice(0, 3);
  }

  // ── 原始匹配（不做去重过滤，用于收集所有策略的候选）────────────────
  function matchHiraganaRaw(ocrText) {
    const clean = normalizeOCRResult(ocrText);
    if (!clean) return null;
    const keys = Object.keys(HIRA_MAP).sort((a, b) => b.length - a.length);
    for (const key of keys) {
      if (clean.includes(key)) return HIRA_MAP[key];
    }
    return null;
  }

  // ── 识别成功回调 ──────────────────────────────────────────────────────
  let pendingItem      = null;   // 等待用户确认的主候选
  let pendingCandidates= [];     // 所有候选（含主候选，按置信度排序）

  function showConfirmDialog(item, candidates) {
    // 暂停自动扫描定时器
    if (scanInterval) { clearInterval(scanInterval); scanInterval = null; }
    pendingItem       = item;
    pendingCandidates = candidates || [item];

    const confirmEl = qs('#scannerConfirm');
    if (!confirmEl) return;

    // 主候选显示
    qs('#confirmChar').textContent   = item.hira;
    qs('#confirmRomaji').textContent = item.romaji;
    confirmEl.classList.add('is-active');
    scanHint.textContent = '認識結果を確認してください';

    // 其他候选（去掉主候选后剩余最多2个）
    const others = pendingCandidates.filter(function (c) { return c.hira !== item.hira; }).slice(0, 2);
    const othersEl = qs('#confirmOthers');
    if (othersEl) {
      if (others.length > 0) {
        othersEl.classList.add('has-others');
        const btnsEl = qs('#confirmOtherBtns');
        btnsEl.innerHTML = '';
        others.forEach(function (other) {
          const btn = document.createElement('button');
          btn.className = 'scanner-confirm-other-btn';
          btn.title = other.romaji;
          btn.textContent = other.hira;
          btn.addEventListener('click', function () {
            // 切换主候选为此项，重新渲染弹窗
            showConfirmDialog(other, pendingCandidates);
          });
          btnsEl.appendChild(btn);
        });
      } else {
        othersEl.classList.remove('has-others');
      }
    }
  }

  function hideConfirmDialog() {
    const confirmEl = qs('#scannerConfirm');
    if (confirmEl) confirmEl.classList.remove('is-active');
    const othersEl = qs('#confirmOthers');
    if (othersEl) othersEl.classList.remove('has-others');
    pendingItem = null;
    pendingCandidates = [];
    // 恢复自动扫描
    if (scanMode === 'auto' && scanStream) {
      scanInterval = setInterval(captureAndRecognize, 1200);
    }
    scanHint.textContent = 'カードをフレーム中央に合わせてください';
  }

  function onCardRecognized(item, candidates) {
    showConfirmDialog(item, candidates);
  }

  // 用户点「正解 ✓」
  if (qs('#confirmOk')) {
    qs('#confirmOk').addEventListener('click', function () {
      if (!pendingItem) return;
      const item = pendingItem;
      hideConfirmDialog();
      scanResultTxt.textContent = `認識: ${item.hira}（${item.romaji}）`;
      scanResult.style.display = 'flex';
      scanHint.textContent = '認識成功！';
      setTimeout(function () {
        stopScanner();
        openModal(item);
        scrollToItem(item);
      }, 1200);
    });
  }

  // 用户点「再挑戦 ✗」
  if (qs('#confirmRetry')) {
    qs('#confirmRetry').addEventListener('click', function () {
      hideConfirmDialog();
    });
  }

  function scrollToItem(item) {
    const card = qs(`[data-hira="${item.hira}"]`);
    if (card) {
      card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      card.classList.add('is-highlighted');
      setTimeout(function () { card.classList.remove('is-highlighted'); }, 3000);
    }
  }

  if (scannerBtn) scannerBtn.addEventListener('click', startScanner);
  if (closeScanBtn) closeScanBtn.addEventListener('click', stopScanner);

  /* ===== 拍照 & 模式切换 ===== */
  const modeAutoBtn   = qs('#modeAuto');
  const modeManualBtn = qs('#modeManual');
  const shutterBtn    = qs('#shutterBtn');

  if (modeAutoBtn) {
    modeAutoBtn.addEventListener('click', function () {
      if (scanMode === 'auto') return;
      scanMode = 'auto';
      modeAutoBtn.classList.add('is-active');
      modeManualBtn.classList.remove('is-active');
      if (shutterBtn) shutterBtn.classList.add('is-disabled');
      if (scanStream && !scanInterval) {
        consecutiveFails = 0;
        scanInterval = setInterval(captureAndRecognize, 1200);
      }
      if (scanHint) scanHint.textContent = 'カードをフレーム中央に合わせてください';
    });
  }

  if (modeManualBtn) {
    modeManualBtn.addEventListener('click', function () {
      if (scanMode === 'manual') return;
      scanMode = 'manual';
      modeManualBtn.classList.add('is-active');
      modeAutoBtn.classList.remove('is-active');
      if (shutterBtn) shutterBtn.classList.remove('is-disabled');
      if (scanInterval) { clearInterval(scanInterval); scanInterval = null; }
      if (scanHint) scanHint.textContent = 'シャッターボタンを押して撮影してください';
    });
  }

  if (shutterBtn) {
    if (scanMode === 'auto') shutterBtn.classList.add('is-disabled');
    shutterBtn.addEventListener('click', async function () {
      if (scanMode !== 'manual' || isProcessing || !tesseractWorker || !scanVideo.videoWidth) return;
      if (scanHint) scanHint.textContent = '認識中...';
      shutterBtn.classList.add('is-disabled');
      await captureAndRecognize();
      shutterBtn.classList.remove('is-disabled');
      if (scanResult && scanResult.style.display !== 'flex') {
        if (scanHint) scanHint.textContent = 'シャッターボタンを押して撮影してください';
      }
    });
  }

  /* ===== 折叠区域（可选展开/收起）===== */
  function initSectionCollapse() {
    qsa('.section-header').forEach(function (header) {
      header.setAttribute('role', 'button');
      header.setAttribute('tabindex', '0');
      header.setAttribute('aria-expanded', 'true');

      function toggle() {
        const section = header.closest('.hira-section');
        const grid    = section.querySelector('.hira-grid');
        const expanded = header.getAttribute('aria-expanded') === 'true';
        header.setAttribute('aria-expanded', String(!expanded));
        grid.style.maxHeight = expanded ? '0' : '';
        grid.style.overflow  = expanded ? 'hidden' : '';
        header.classList.toggle('is-collapsed', expanded);
      }

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ===== 初始化 ===== */
  document.addEventListener('DOMContentLoaded', function () {
    initGrids();
    initSectionCollapse();
  });

  // 如果 DOMContentLoaded 已触发
  if (document.readyState !== 'loading') {
    initGrids();
    initSectionCollapse();
  }

})();
